exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#admin_excluded_referrals_page .edit-excluded-referral {\n  width: auto;\n  height: 3.4rem;\n}\n#admin_excluded_referrals_page .cancel-editing {\n  padding: 0.8rem 1.65rem;\n}\n#admin_excluded_referrals_page .VueTables__table {\n  table-layout: fixed;\n}", ""]);

// exports
